export default {
  REPAIR_SHOP: "repairShop",
  VEHICLE_DAMAGE_INSPECTION_POINT: "vehicleDamageInspectionPoint",
  BUSINESS_UNIT: "businessUnit",
  PHOTO: "photo",
  NOT_DRIVEABLE: "notDriveable",
}